<template>
  <teleport to="body">
    <div
      class="network_dropdown"
      v-if="isOpen"
      :style="dropdownStyle"
      @pointerdown.stop
      @mousedown.stop
      @touchstart.stop
      @click.stop
    >
      <div class="dropdown_wrapper">
        <div
          v-for="value in networks"
          :key="value.name"
          class="dropdown_item"
          @click="selectNetwork(value.value)"
        >
          <div class="background_rectangle"></div>
          <div class="left_addon">
            <BaseSvgIcon :name="value.icon" class="network_icon" />
          </div>
          <div class="content">
            <div class="label">{{ $t(value.name) }}</div>
            <div class="description">{{ value.subtitle }}</div>
          </div>
          <div class="right_addon">
            <div class="checkbox" v-if="currentNetwork === value.value">
              <BaseSvgIcon name="green_checkbox" class="check_icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import BaseSvgIcon from "@/shared/ui/BaseSvgIcon/BaseSvgIcon.vue";
import { computed } from "vue";
import "@/assets/icons/SVG/all-networks.svg";
import "@/assets/icons/SVG/tron.svg";
import "@/assets/icons/SVG/bitcoin.svg";
import "@/assets/icons/SVG/ton.svg";
// import "@/assets/icons/SVG/usdt.svg";
// import "@/assets/icons/SVG/eth.svg";
import "@/assets/icons/SVG/green_checkbox.svg";
import { useStore } from "vuex";

const networks = [
  {
    name: "network-selector.all-networks",
    subtitle: "",
    icon: "all-networks",
    value: "",
  },
  {
    name: "Bitcoin",
    subtitle: "BTC",
    icon: "bitcoin",
    value: "bitcoin",
  },
  {
    name: "Ethereum",
    subtitle: "ETH",
    icon: "ethereum",
    value: "ethereum",
  },
  {
    name: "Tron",
    subtitle: "TRC-20",
    icon: "tron",
    value: "tron",
  },
  {
    name: "Ton",
    subtitle: "TON",
    icon: "ton",
    value: "ton",
  },
];

// Props
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  anchorRect: {
    type: Object,
    default: null,
  },
  selectedNetworks: {
    type: Array,
    default: () => [],
  },
});

const store = useStore();

const currentNetwork = computed(
  () => store.getters["explorer/getCurrentNetwork"],
);

// Emits
const emit = defineEmits(["update:selectedNetworks", "selectNetwork"]);

// Methods
const selectNetwork = (network) => {
  console.log("selectNetwork", network);
  store.commit("explorer/SET_CURRENT_NETWORK", network);
  emit("selectNetwork", network);
};

// Positioning style for teleport
const dropdownStyle = computed(() => {
  // If anchorRect is provided, position relative to viewport using fixed coords
  if (
    typeof props.anchorRect === "object" &&
    props.anchorRect &&
    "top" in props.anchorRect
  ) {
    const gap = 9; // visual gap below the trigger (matches previous design)
    const leftOffset = -11; // preserve previous slight left shift
    return {
      position: "fixed",
      top: `${props.anchorRect.bottom + gap}px`,
      left: `${props.anchorRect.left + leftOffset}px`,
    };
  }
  // Fallback to original absolute positioning
  return {};
});
</script>

<style lang="scss" scoped>
.network_dropdown {
  position: fixed;
  z-index: 999;
  width: 326px;
  @media (width < 768px) {
    width: calc(100vw - 32px);
  }
}

.dropdown_wrapper {
  background: #1a1a1a;
  border: 1px solid #232323;
  border-radius: 12px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dropdown_item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #2d2d2d;
  }
}

.bitcoin_bg {
  background: #232323;
}

.left_addon {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
}

.network_icon {
  width: 32px;
  height: 32px;
  color: #ffffff;
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 8px;
  flex: 1;
}

.label {
  font-family: "Roobert PRO", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  color: #fafafa;
  text-align: left;
}

.description {
  font-family: "Roobert PRO", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.5em;
  color: #a3a3a3;
  text-align: left;
}

.right_addon {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
  height: 100%;
  width: 20px;
}

.checkbox {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid transparent;
  transition: all 0.2s ease;

  &.active {
    background: #43a047;
    border-color: #43a047;
  }
}

.check_icon {
  width: 16px;
  height: 16px;
  color: #fafafa;
  stroke-width: 1.5px;
}
</style>
